import { memo } from "react";
import { PageLayoutHeader, PageLayoutHeaderProps } from "../../PageLayout";

export type EntityPageLayoutHeaderProps = PageLayoutHeaderProps & {
  isFetching?: boolean
};

export const EntityPageLayoutHeader = memo<EntityPageLayoutHeaderProps>((
  {
    isFetching = false,
    header,
    buttons,
    ...props
  }) => {

  return (
    <PageLayoutHeader
      header={isFetching ? "Loading..." : header}
      buttons={!isFetching ? buttons : undefined}
      {...props}
    />
  );
});

export default EntityPageLayoutHeader;
